import React from 'react'
import PropTypes from 'prop-types'
import { CButton } from '@coreui/react-pro'
import * as Icon from 'react-bootstrap-icons'

const RetryButton = ({
  onClick,
  label = 'Повторить',
  color = 'primary',
  size = 'sm',
  className,
}) => {
  if (!onClick) return null

  return (
    <CButton color={color} variant="outline" size={size} className={className} onClick={onClick}>
      <Icon.ArrowClockwise className="me-1" />
      {label}
    </CButton>
  )
}

RetryButton.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.string,
  className: PropTypes.string,
}

export default RetryButton
